import { cx } from '@hrworks/design-system/functions';

import { useResolveImageSrc } from '../Image';
import { S } from './Logo.styles';
import type { LogoProps } from './Logo.types';

export const Logo = ({
  alt,
  className,
  href,
  onClick,
  ref,
  src: srcFromProps,
  target,
  title,
  ...otherProps
}: LogoProps) => {
  const { src } = useResolveImageSrc(srcFromProps ?? '');

  return (
    <S.LogoContainer ref={ref} className={cx(S.cls.LogoContainer, className)} {...otherProps}>
      <S.LogoLink
        className={S.cls.LogoLink}
        href={href}
        target={target}
        onClick={onClick}
        {...(onClick &&
          !href && {
            tabIndex: 0,
            role: 'button',
            onKeyDown: (e: React.KeyboardEvent<HTMLAnchorElement>) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.currentTarget.click();
              }
            },
          })}
        {...(!onClick && !href && { role: 'presentation' })}
      >
        {srcFromProps && <S.Logo className={S.cls.Logo} alt={alt} src={src} />}
        {title && (
          <S.Title className={S.cls.Title} overflowBehaviour="ellipsis" component="div">
            {title}
          </S.Title>
        )}
      </S.LogoLink>
    </S.LogoContainer>
  );
};
